module.exports = __webpack_public_path__ + "img/bakery-bags.0c3ab8d0.png";